import { Vue, prop } from 'vue-class-component';
import clsx from 'clsx';
import styles from './styles.module.scss';

export enum IconNames {
	'close' = 'close',
	'userCircle' = 'userCircle',
	'expandMore' = 'expandMore',
	'expandLess' = 'expandLess',
	'calc' = 'calc',
	'cash' = 'cash',
	'key' = 'key',
	'info' = 'info',
	'arrowLeft' = 'arrowLeft',
	'localMovies'= 'localMovies',
	'libraryBooks'= 'libraryBooks',
	'check' = 'check',
	'arrowDropDown' = 'arrowDropDown',
	'error' = 'error',
	'boldCheck' = 'boldCheck',
	'camera' = 'camera',
	'checkCircle' = 'checkCircle',
	'circle' = 'circle',
	'unCheckCircle' = 'unCheckCircle',
	'roundCheck' = 'roundCheck',
	'accessTime' = 'accessTime',
	'impact' = 'impact',
	'ssn' = 'ssn',
	'secure' = 'secure',
	'errorIcon' = 'errorIcon',
	'pending' = 'pending',
	'next' = 'next',
	'blankCircle' = 'blankCircle',
	'failed' = 'failed',
	'dollarBox' = 'dollarBox',
	'calendarBasic' = 'calendarBasic',
	'calendar' = 'calendar',
	'clock' = 'clock',
	'lock' = 'lock',
	'pencil' = 'pencil',
}

class IconProp {
	size = prop<number>({ default: 24 });

	name = prop<IconNames>({ required: true });

	color = prop<string>({ default: 'currentColor' });

	backgroundColor = prop<string>({ default: 'white' });

	title = prop<string>({ default: null });

	wrapped = prop<boolean>({ default: false });
}

export class Icon extends Vue.with(IconProp) {
	icons = {
		close: {
			viewBox: '0 0 24 24',
			title: 'Close',
			path: 'M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z',
		},
		userCircle: {
			viewBox: '0 0 24 24',
			title: 'User Icon',
			path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3zm0 14.2a7.2 7.2 0 0 1-6-3.22c.03-1.99 4-3.08 6-3.08c1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 0 1-6 3.22z',
		},
		expandMore: {
			viewBox: '0 0 24 24',
			title: 'Expand More',
			path: 'M16.59 8.59L12 13.17L7.41 8.59L6 10l6 6l6-6z',
		},
		expandLess: {
			viewBox: '0 0 24 24',
			title: 'Expand Less',
			path: 'M12 8l-6 6l1.41 1.41L12 10.83l4.59 4.58L18 14z',
		},
		key: {
			viewBox: '0 0 22 22',
			title: 'Key',
			path: 'M22,17.6 L22,22 L17.6,22 L17.6,18.7 L14.3,18.7 L14.3,15.4 L11,15.4 L8.514,12.914 C7.909,13.101 7.271,13.2 6.6,13.2 C2.95492065,13.2 0,10.2450793 0,6.6 C0,2.95492065 2.95492065,0 6.6,0 C10.2450793,0 13.2,2.95492065 13.2,6.6 C13.2,7.271 13.101,7.909 12.914,8.514 L22,17.6 M5.5,3.3 C4.28497355,3.3 3.3,4.28497355 3.3,5.5 C3.3,6.71502645 4.28497355,7.7 5.5,7.7 C6.71502645,7.7 7.7,6.71502645 7.7,5.5 C7.7,4.28497355 6.71502645,3.3 5.5,3.3 Z',
		},
		calc: {
			viewBox: '0 0 16 23',
			title: 'Calculator',
			path: 'M2.28571429,0 L13.7142857,0 C14.9766509,0 16,1.02334914 16,2.28571429 L16,20.5714286 C16,21.8337937 14.9766509,22.8571429 13.7142857,22.8571429 L2.28571429,22.8571429 C1.02334914,22.8571429 0,21.8337937 0,20.5714286 L0,2.28571429 C0,1.02334914 1.02334914,0 2.28571429,0 M2.28571429,2.28571429 L2.28571429,6.85714286 L13.7142857,6.85714286 L13.7142857,2.28571429 L2.28571429,2.28571429 M2.28571429,9.14285714 L2.28571429,11.4285714 L4.57142857,11.4285714 L4.57142857,9.14285714 L2.28571429,9.14285714 M6.85714286,9.14285714 L6.85714286,11.4285714 L9.14285714,11.4285714 L9.14285714,9.14285714 L6.85714286,9.14285714 M11.4285714,9.14285714 L11.4285714,11.4285714 L13.7142857,11.4285714 L13.7142857,9.14285714 L11.4285714,9.14285714 M2.28571429,13.7142857 L2.28571429,16 L4.57142857,16 L4.57142857,13.7142857 L2.28571429,13.7142857 M6.85714286,13.7142857 L6.85714286,16 L9.14285714,16 L9.14285714,13.7142857 L6.85714286,13.7142857 M11.4285714,13.7142857 L11.4285714,16 L13.7142857,16 L13.7142857,13.7142857 L11.4285714,13.7142857 M2.28571429,18.2857143 L2.28571429,20.5714286 L4.57142857,20.5714286 L4.57142857,18.2857143 L2.28571429,18.2857143 M6.85714286,18.2857143 L6.85714286,20.5714286 L9.14285714,20.5714286 L9.14285714,18.2857143 L6.85714286,18.2857143 M11.4285714,18.2857143 L11.4285714,20.5714286 L13.7142857,20.5714286 L13.7142857,18.2857143 L11.4285714,18.2857143 Z',
		},
		cash: {
			viewBox: '0 0 23 18',
			title: 'Cache',
			path: 'M20.7,0 L2.3,0 C1.0235,0 0,1.00125 0,2.25 L0,15.75 C0,16.99875 1.035,18 2.3,18 L20.7,18 C21.9765,18 23,16.99875 23,15.75 L23,2.25 C23,1.00125 21.965,0 20.7,0 M14.95,6.75 L10.35,6.75 L10.35,7.875 L13.8,7.875 C14.4325,7.875 14.95,8.38125 14.95,9 L14.95,12.375 C14.95,12.99375 14.4325,13.5 13.8,13.5 L12.65,13.5 L12.65,14.625 L10.35,14.625 L10.35,13.5 L8.05,13.5 L8.05,11.25 L12.65,11.25 L12.65,10.125 L9.2,10.125 C8.5675,10.125 8.05,9.61875 8.05,9 L8.05,5.625 C8.05,5.00625 8.5675,4.5 9.2,4.5 L10.35,4.5 L10.35,3.375 L12.65,3.375 L12.65,4.5 L14.95,4.5 L14.95,6.75 Z',
		},
		info: {
			viewBox: '0 0 24 24',
			title: 'Info',
			path: 'M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8z',
		},
		arrowLeft: {
			viewBox: '0 0 14 11',
			title: 'Arrow Left',
			path: 'M0.771106 4.96234L4.79587 0.937567C5.10981 0.623676 5.61694 0.623676 5.93088 0.937567C6.24477 1.25151 6.24477 1.75864 5.93088 2.07258L3.28255 4.72086H12.5798C13.0225 4.72086 13.3847 5.08309 13.3847 5.52581C13.3847 5.97658 13.0225 6.33076 12.5798 6.33076H3.28255L5.93088 8.9871C6.24477 9.30104 6.24477 9.80817 5.93088 10.1221C5.60436 10.4486 5.07793 10.4191 4.79587 10.1221L0.771106 6.09734C0.457158 5.7834 0.457158 5.27628 0.771106 4.96234Z',
		},
		check: {
			viewBox: '0 0 36 36',
			title: 'Ok',
			path: 'M13.5 24.26l-6.26-6.26-2.12 2.12 8.38 8.38 18-18-2.12-2.12z',
		},
		arrowDropDown: {
			viewBox: '0 0 36 36',
			title: 'Drop Down',
			path: 'M10.5 15l7.5 7.5 7.5-7.5z',
		},
		error: {
			viewBox: '0 0 44 44',
			title: 'Error',
			path: 'M22,3.66666667 C11.88,3.66666667 3.66666667,11.88 3.66666667,22 C3.66666667,32.12 11.88,40.3333333 22,40.3333333 C32.12,40.3333333 40.3333333,32.12 40.3333333,22 C40.3333333,11.88 32.12,3.66666667 22,3.66666667 L22,3.66666667 Z M23.8333333,31.1666667 L20.1666667,31.1666667 L20.1666667,27.5 L23.8333333,27.5 L23.8333333,31.1666667 L23.8333333,31.1666667 Z M23.8333333,23.8333333 L20.1666667,23.8333333 L20.1666667,12.8333333 L23.8333333,12.8333333 L23.8333333,23.8333333 L23.8333333,23.8333333 Z',
		},
		accessTime: {
			viewBox: '0 0 24 24',
			title: 'Access Time',
			path: 'M12.9891667,2.16666667 C7.00916667,2.16666667 2.16666667,7.02 2.16666667,13 C2.16666667,18.98 7.00916667,23.8333333 12.9891667,23.8333333 C18.98,23.8333333 23.8333333,18.98 23.8333333,13 C23.8333333,7.02 18.98,2.16666667 12.9891667,2.16666667 L12.9891667,2.16666667 Z M13,4.33333333 C17.7883333,4.33333333 21.6666667,8.21166667 21.6666667,13 C21.6666667,17.7883333 17.7883333,21.6666667 13,21.6666667 C8.21166667,21.6666667 4.33333333,17.7883333 4.33333333,13 C4.33333333,8.21166667 8.21166667,4.33333333 13,4.33333333 Z M13.5416667,7.58333333 L11.9166667,7.58333333 L11.9166667,14.0833333 L17.6041667,17.4958333 L18.4166667,16.1633333 L13.5416667,13.2708333 L13.5416667,7.58333333 Z',
		},
		impact: {
			viewBox: '0 0 26 20',
			title: 'Impact',
			path: 'M13 0.131577C5.85 0.131577 0 6.05263 0 13.2895V14.6053H5.2V11.9737H2.73C2.99 10 3.64 8.28947 4.81 6.8421L6.5 8.68421L8.32 6.8421L6.63 5C8.06 3.81579 9.75 3.15789 11.7 2.89473V5.39473H14.3V2.89473C16.25 3.15789 17.94 3.94737 19.37 5L17.55 6.8421L19.37 8.68421L21.19 6.8421C22.36 8.28947 23.01 10 23.27 11.9737H20.8V14.6053H26V13.2895C26 6.05263 20.15 0.131577 13 0.131577Z M14.2996 8.02631V12.2368C15.8596 12.7632 16.8996 14.2105 16.8996 15.9211C16.8996 18.1579 15.2096 19.8684 12.9996 19.8684C10.7896 19.8684 9.09961 18.1579 9.09961 15.9211C9.09961 14.2105 10.1396 12.7632 11.6996 12.2368V8.02631H14.2996ZM11.6996 15.9211C11.6996 16.7105 12.2196 17.2368 12.9996 17.2368C13.6496 17.2368 14.2996 16.7105 14.2996 15.9211C14.2996 15.1316 13.7796 14.6053 12.9996 14.6053C12.2196 14.6053 11.6996 15.1316 11.6996 15.9211Z',
		},
		ssn: {
			viewBox: '0 0 26 26',
			title: 'SSN',
			path: 'M13,2.16666667 C7.04166667,2.16666667 2.16666667,7.04166667 2.16666667,13 C2.16666667,18.9583333 7.04166667,23.8333333 13,23.8333333 C18.9583333,23.8333333 23.8333333,18.9583333 23.8333333,13 C23.8333333,7.04166667 18.9583333,2.16666667 13,2.16666667 L13,2.16666667 Z M4.33333333,13 C4.33333333,8.23333333 8.23333333,4.33333333 13,4.33333333 C14.95,4.33333333 16.7916667,4.98333333 18.3083333,6.175 L6.175,18.3083333 C4.98333333,16.7916667 4.33333333,14.95 4.33333333,13 L4.33333333,13 Z M13,21.6666667 C11.05,21.6666667 9.20833333,21.0166667 7.69166667,19.825 L19.825,7.69166667 C21.0166667,9.20833333 21.6666667,11.05 21.6666667,13 C21.6666667,17.7666667 17.7666667,21.6666667 13,21.6666667 L13,21.6666667 Z',
		},
		secure: {
			viewBox: '0 0 26 26',
			title: 'Secure',
			path: 'M13,1.08333333 L3.25,5.41666667 L3.25,11.9166667 C3.25,17.9291667 7.41,23.5516667 13,24.9166667 C18.59,23.5516667 22.75,17.9291667 22.75,11.9166667 L22.75,5.41666667 L13,1.08333333 L13,1.08333333 Z M13,12.9891667 L20.5833333,12.9891667 C20.0091667,17.4525 17.03,21.4283333 13,22.6741667 L13,13 L5.41666667,13 L5.41666667,6.825 L13,3.45583333 L13,12.9891667 L13,12.9891667 Z',
		},
		localMovies: {
			viewBox: '0 0 24 24',
			title: 'Local Movies',
			path: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z',
		},
		libraryBooks: {
			viewBox: '0 0 24 24',
			title: 'Library Books',
			path: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z',
		},
		checkCircle: {
			viewBox: '0 0 24 24',
			title: 'Check Circle',
			path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
		},
		circle: {
			viewBox: '0 0 29.107 29.107',
			title: 'Circle',
			path: 'M14.554,0C6.561,0,0,6.562,0,14.552c0,7.996,6.561,14.555,14.554,14.555c7.996,0,14.553-6.559,14.553-14.555C29.106,6.562,22.55,0,14.554,0z',
		},
		unCheckCircle: {
			viewBox: '0 0 24 24',
			title: 'Uncheck Circle',
			path: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
		},
		roundCheck: {
			viewBox: '0 0 36 36',
			title: 'Ok',
			path: 'M18.3835 0C28.5308 0 36.767 8.23618 36.767 18.3835C36.767 28.5308 28.5308 36.767 18.3835 36.767C8.23618 36.767 0 28.5308 0 18.3835C0 8.23618 8.23618 0 18.3835 0ZM15.4854 20.3064L25.3856 10.4062L28.2414 13.3001L15.4854 26.0181L8.47917 19.0118L11.335 16.1179L15.4854 20.3064Z',
		},
		errorIcon: {
			viewBox: '0 0 44 44',
			title: 'Error Icon',
			path: 'M22 3.667C11.88 3.667 3.667 11.88 3.667 22S11.88 40.333 22 40.333 40.333 32.12 40.333 22 32.12 3.667 22 3.667zm1.833 27.5h-3.666V27.5h3.666v3.667zm0-7.334h-3.666v-11h3.666v11z',
		},
		boldCheck: {
			viewBox: '0 0 19.8 15.6',
			title: 'Ok',
			path: 'M 0 8.82 L 2.89 5.854 L 7.091 10.146 L 17.11 0 L 20 2.966 L 7.091 16 L 0 8.82 Z',
		},
		camera: {
			viewBox: '0 0 36 36',
			title: 'Camera',
			path: 'M13.75 1.833l1.678 1.834h2.905c1.009 0 1.834.825 1.834 1.833v11c0 1.008-.825 1.833-1.834 1.833H3.667c-1.009 0-1.834-.825-1.834-1.833v-11c0-1.008.825-1.833 1.834-1.833h2.905L8.25 1.833h5.5zM11 6.417C8.47 6.417 6.417 8.47 6.417 11c0 2.53 2.053 4.583 4.583 4.583 2.53 0 4.583-2.053 4.583-4.583 0-2.53-2.053-4.583-4.583-4.583zm0 1.65c1.62 0 2.933 1.313 2.933 2.933 0 1.62-1.313 2.933-2.933 2.933-1.62 0-2.933-1.313-2.933-2.933 0-1.62 1.313-2.933 2.933-2.933z',
		},
		calendar: {
			viewBox: '0 0 512 512',
			title: 'Calendar',
			path: 'm446 40h-46v-24c0-8.836-7.163-16-16-16s-16 7.164-16 16v24h-224v-24c0-8.836-7.163-16-16-16s-16 7.164-16 16v24h-46c-36.393 0-66 29.607-66 66v340c0 36.393 29.607 66 66 66h380c36.393 0 66-29.607 66-66v-340c0-36.393-29.607-66-66-66zm34 406c0 18.778-15.222 34-34 34h-380c-18.778 0-34-15.222-34-34v-265c0-2.761 2.239-5 5-5h438c2.761 0 5 2.239 5 5z',
		},
		clock: {
			viewBox: '0 0 315 315',
			title: 'Clock',
			path: 'M 157.5 19.688 C 81.507 19.688 19.688 81.507 19.688 157.5 C 19.688 233.493 81.507 295.313 157.5 295.313 C 233.493 295.313 295.313 233.493 295.313 157.5 C 295.313 81.507 233.493 19.688 157.5 19.688 L 157.5 19.688 Z  M 157.5 315 C 70.651 315 0 244.349 0 157.5 C 0 70.651 70.651 0 157.5 0 C 244.349 0 315 70.651 315 157.5 C 315 244.349 244.349 315 157.5 315 L 157.5 315 Z  M 226.406 242.813 C 223.885 242.813 221.367 241.854 219.449 239.925 L 150.543 171.018 C 148.692 169.168 147.656 166.661 147.656 164.063 L 147.656 72.187 C 147.656 66.753 152.066 62.343 157.5 62.343 C 162.934 62.343 167.344 66.753 167.344 72.187 L 167.344 159.98 L 233.364 226 C 237.209 229.845 237.209 236.079 233.364 239.925 C 231.446 241.854 228.927 242.813 226.406 242.813 L 226.406 242.813 Z',
		},
		pending: {
			viewBox: '0 0 24 24',
			title: 'Pending',
			path: 'M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z',
		},
		next: {
			viewBox: '0 0 24 24',
			title: 'Next',
			path: 'M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z',
		},
		blankCircle: {
			viewBox: '0 0 24 24',
			title: 'Blank Circle',
			path: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
		},
		failed: {
			viewBox: '0 0 24 24',
			title: 'Failed',
			path: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z',
		},
		dollarBox: {
			viewBox: '0 0 24 24',
			title: 'Dollar Box',
			path: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z',
		},
		calendarBasic: {
			viewBox: '0 0 24 24',
			title: 'Calendar Basic',
			path: 'M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z',
		},
		lock: {
			viewBox: '0 0 24 24',
			title: 'Lock',
			path: 'M21,9.33333333 L19.8333333,9.33333333 L19.8333333,7 C19.8333333,3.78 17.22,1.16666667 14,1.16666667 C10.78,1.16666667 8.16666667,3.78 8.16666667,7 L8.16666667,9.33333333 L7,9.33333333 C5.71666667,9.33333333 4.66666667,10.3833333 4.66666667,11.6666667 L4.66666667,23.3333333 C4.66666667,24.6166667 5.71666667,25.6666667 7,25.6666667 L21,25.6666667 C22.2833333,25.6666667 23.3333333,24.6166667 23.3333333,23.3333333 L23.3333333,11.6666667 C23.3333333,10.3833333 22.2833333,9.33333333 21,9.33333333 L21,9.33333333 Z M14,19.8333333 C12.7166667,19.8333333 11.6666667,18.7833333 11.6666667,17.5 C11.6666667,16.2166667 12.7166667,15.1666667 14,15.1666667 C15.2833333,15.1666667 16.3333333,16.2166667 16.3333333,17.5 C16.3333333,18.7833333 15.2833333,19.8333333 14,19.8333333 L14,19.8333333 Z M17.6166667,9.33333333 L10.3833333,9.33333333 L10.3833333,7 C10.3833333,5.005 12.005,3.38333333 14,3.38333333 C15.995,3.38333333 17.6166667,5.005 17.6166667,7 L17.6166667,9.33333333 L17.6166667,9.33333333 Z',
		},
		pencil: {
			viewBox: '0 0 24 24',
			title: 'Edit',
			path: 'M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z',
		},
	}

	render() {
		const { viewBox, title, path } = this.icons[this.name];
		let style = `--icon-size: ${this.size}px;`;

		if (this.wrapped) { style += `--icon-background-color: ${this.backgroundColor};`; }

		return (
			<div class={ clsx(styles.icon, this.wrapped && styles.iconWrapped) }
				style={ style }>
				<svg xmlns="http://www.w3.org/2000/svg"
					viewBox={ viewBox }
					width="100%"
					height="100%"
					data-name={ this.name }
					role="presentation"
				>
					<title lang="en">{ this.title || title }</title>
					<g fill={ this.color }>
						<path d={ path }></path>
					</g>
				</svg>
			</div>
		);
	}
}
